package com.marcinmoskala.albert.presentation.markdown

import io.ktor.client.HttpClient
import io.ktor.client.plugins.HttpTimeout

actual fun createMarkdownHttpClient(): HttpClient =
    HttpClient {
        expectSuccess = false
        install(HttpTimeout) {
            requestTimeoutMillis = 15_000
            connectTimeoutMillis = 10_000
        }
    }